export const memberAccountStorageKeys = ["current_member_account", "memberAccount"] as const;
export const memberIdentityCodeStorageKeys = [
  "current_member_identity_code",
  "memberIdentityCode",
  "current_identity_code",
  "identity_code",
  "phone_last3",
] as const;

export interface StoredLobbyMemberIdentity {
  account: string;
  identityCode: string;
}

export function readStoredMemberAccount() {
  return readFirstStorageValue(memberAccountStorageKeys);
}

export function readStoredMemberIdentityCode() {
  return readFirstStorageValue(memberIdentityCodeStorageKeys);
}

export function readStoredLobbyMemberIdentity(): StoredLobbyMemberIdentity | null {
  const account = readStoredMemberAccount();
  const identityCode = readStoredMemberIdentityCode();
  if (!account || !identityCode) return null;
  return { account, identityCode };
}

export function writeStoredLobbyMemberIdentity(account: string, identityCode: string) {
  const cleanAccount = account.trim();
  const cleanIdentityCode = identityCode.trim();
  if (!cleanAccount) return;

  writeStorageValue("current_member_account", cleanAccount);
  writeStorageValue("memberAccount", cleanAccount);

  if (!cleanIdentityCode) return;
  writeStorageValue("current_member_identity_code", cleanIdentityCode);
  writeStorageValue("memberIdentityCode", cleanIdentityCode);
}

export function clearStoredLobbyMemberIdentity() {
  for (const key of memberAccountStorageKeys) removeStorageValue(key);
  for (const key of memberIdentityCodeStorageKeys) removeStorageValue(key);
}

function readFirstStorageValue(keys: readonly string[]) {
  for (const key of keys) {
    const value = readStorageValue(key);
    if (value) return value;
  }
  return "";
}

function readStorageValue(key: string) {
  try {
    return localStorage.getItem(key)?.trim() ?? "";
  } catch {
    return "";
  }
}

function writeStorageValue(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Browser storage can be disabled; the member session cookie remains authoritative.
  }
}

function removeStorageValue(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore storage failures during logout.
  }
}
